var tiles = require('@code-dot-org/maze').tiles;
var Direction = tiles.Direction;

var blockUtils = require('../block_utils');
var utils = require('../utils');

var karelLevels = require('./karelLevels');
var mazeMsg = require('./locale');
var reqBlocks = require('./requiredBlocks');
var wordsearchLevels = require('./wordsearchLevels');

//TODO: Fix hacky level-number-dependent toolbox.
var toolbox = function (page, level) {
  return require('./toolboxes/maze.xml.ejs')({
    page: page,
    level: level,
  });
};

//TODO: Fix hacky level-number-dependent startBlocks.
var startBlocks = function (page, level) {
  return require('./startBlocks.xml.ejs')({
    page: page,
    level: level,
  });
};

/*
 * Configuration for all levels.
 */
module.exports = {
  // Formerly Page 2

  '2_1': {
    toolbox: toolbox(2, 1),
    ideal: 4,
    requiredBlocks: [[reqBlocks.MOVE_FORWARD]],
    startDirection: Direction.EAST,
    map: [
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 2, 1, 1, 3, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
    ],
    startBlocks: startBlocks(2, 1),
  },
  k1_demo: {
    toolbox: blockUtils.createToolbox(
      blockUtils.blockOfType('maze_moveNorth') +
        blockUtils.blockOfType('maze_moveSouth') +
        blockUtils.blockOfType('maze_moveEast') +
        blockUtils.blockOfType('maze_moveWest') +
        blockUtils.blockOfType('controls_repeat_simplified')
    ),
    ideal: 4,
    requiredBlocks: [[reqBlocks.MOVE_FORWARD]],
    startDirection: Direction.EAST,
    map: [
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 2, 1, 1, 3, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
    ],
    startBlocks: startBlocks(2, 1),
  },
  '2_2': {
    instructionsImportant: true,
    toolbox: toolbox(2, 2),
    ideal: 3,
    requiredBlocks: [[reqBlocks.MOVE_FORWARD]],
    startDirection: Direction.SOUTH,
    map: [
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 2, 0, 0, 0, 0],
      [0, 0, 0, 1, 0, 0, 0, 0],
      [0, 0, 0, 3, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
    ],
    startBlocks: startBlocks(2, 2),
  },
  '2_2_5': {
    toolbox: toolbox(2, 3),
    ideal: 5,
    requiredBlocks: [[reqBlocks.MOVE_FORWARD], [reqBlocks.TURN_RIGHT]],
    startDirection: Direction.EAST,
    map: [
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 4, 0, 0, 0],
      [0, 0, 2, 1, 1, 0, 0, 0],
      [0, 0, 4, 0, 3, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
    ],
    startBlocks: startBlocks(2, 3),
  },
  '2_3': {
    toolbox: toolbox(2, 3),
    ideal: 6,
    requiredBlocks: [
      [reqBlocks.MOVE_FORWARD],
      [reqBlocks.TURN_LEFT],
      [reqBlocks.TURN_RIGHT],
    ],
    startDirection: Direction.EAST,
    map: [
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 4, 1, 3, 0, 0, 0],
      [0, 0, 2, 1, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
    ],
    startBlocks: startBlocks(2, 3),
  },
  '2_4': {
    toolbox: toolbox(2, 4),
    ideal: 9,
    requiredBlocks: [
      [reqBlocks.MOVE_FORWARD],
      [reqBlocks.TURN_LEFT],
      [reqBlocks.TURN_RIGHT],
    ],
    startDirection: Direction.EAST,
    map: [
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 2, 4, 0, 3, 0, 0],
      [0, 0, 1, 1, 1, 1, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
    ],
  },
  '2_5': {
    toolbox: toolbox(2, 5),
    ideal: 3,
    requiredBlocks: [[reqBlocks.MOVE_FORWARD], [reqBlocks.FOR_LOOP]],
    startDirection: Direction.EAST,
    map: [
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 2, 1, 1, 1, 1, 3, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
    ],
  },
  '2_6': {
    toolbox: toolbox(2, 6),
    ideal: 4,
    requiredBlocks: [
      [reqBlocks.TURN_RIGHT],
      [reqBlocks.MOVE_FORWARD],
      [reqBlocks.FOR_LOOP],
    ],
    startDirection: Direction.EAST,
    map: [
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 2, 0, 0, 0],
      [0, 0, 0, 0, 1, 0, 0, 0],
      [0, 0, 0, 0, 1, 0, 0, 0],
      [0, 0, 0, 0, 1, 0, 0, 0],
      [0, 0, 0, 0, 1, 0, 0, 0],
      [0, 0, 0, 0, 3, 0, 0, 0],
    ],
  },
  '2_7': {
    toolbox: toolbox(2, 7),
    ideal: 6,
    requiredBlocks: [
      [reqBlocks.MOVE_FORWARD],
      [reqBlocks.FOR_LOOP],
      [reqBlocks.TURN_LEFT],
    ],
    startDirection: Direction.EAST,
    map: [
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 3, 0],
      [0, 0, 0, 0, 0, 0, 1, 0],
      [0, 0, 0, 0, 0, 0, 1, 0],
      [0, 0, 0, 0, 0, 0, 1, 0],
      [0, 0, 0, 0, 0, 0, 1, 0],
      [0, 0, 2, 1, 1, 1, 1, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
    ],
  },
  '2_8': {
    toolbox: toolbox(2, 8),
    ideal: 5,
    requiredBlocks: [
      [reqBlocks.MOVE_FORWARD],
      [reqBlocks.FOR_LOOP],
      [reqBlocks.TURN_RIGHT],
    ],
    startDirection: Direction.EAST,
    map: [
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 2, 1, 1, 0, 0, 0],
      [0, 0, 0, 0, 1, 0, 0, 0],
      [0, 0, 3, 1, 1, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
    ],
    startBlocks: startBlocks(2, 8),
    levelIncompleteError: mazeMsg.repeatCarefullyError(),
    tooFewBlocksMsg: mazeMsg.repeatCarefullyError(),
  },
  '2_9': {
    toolbox: toolbox(2, 9),
    ideal: 3,
    requiredBlocks: [[reqBlocks.MOVE_FORWARD], [reqBlocks.WHILE_LOOP]],
    startDirection: Direction.EAST,
    map: [
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 2, 1, 1, 1, 1, 3, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
    ],
  },
  '2_10': {
    toolbox: toolbox(2, 10),
    ideal: 5,
    requiredBlocks: [
      [reqBlocks.MOVE_FORWARD],
      [reqBlocks.TURN_LEFT],
      [reqBlocks.WHILE_LOOP],
    ],
    startDirection: Direction.EAST,
    map: [
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 3, 1, 1, 0, 0, 0],
      [0, 0, 0, 0, 1, 0, 0, 0],
      [0, 0, 2, 1, 1, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
    ],
  },
  '2_11': {
    toolbox: toolbox(2, 11),
    ideal: 6,
    scale: {
      stepSpeed: 3,
    },
    requiredBlocks: [
      [reqBlocks.MOVE_FORWARD],
      [reqBlocks.WHILE_LOOP],
      [reqBlocks.TURN_LEFT],
      [reqBlocks.TURN_RIGHT],
    ],
    startDirection: Direction.EAST,
    map: [
      [0, 0, 0, 0, 0, 0, 0, 1],
      [0, 0, 0, 0, 0, 0, 3, 1],
      [0, 0, 0, 0, 0, 1, 1, 0],
      [0, 0, 0, 0, 1, 1, 0, 0],
      [0, 0, 0, 1, 1, 0, 0, 0],
      [0, 0, 1, 1, 0, 0, 0, 0],
      [0, 1, 1, 0, 0, 0, 0, 0],
      [2, 1, 0, 0, 0, 0, 0, 0],
    ],
  },
  '2_12': {
    toolbox: toolbox(2, 12),
    ideal: 6,
    scale: {
      stepSpeed: 3,
    },
    requiredBlocks: [
      [reqBlocks.MOVE_FORWARD],
      [reqBlocks.WHILE_LOOP],
      [reqBlocks.TURN_LEFT],
      [reqBlocks.TURN_RIGHT],
    ],
    startDirection: Direction.EAST,
    map: [
      [1, 0, 0, 0, 0, 0, 0, 0],
      [1, 2, 4, 0, 0, 0, 0, 0],
      [0, 1, 1, 0, 0, 0, 0, 0],
      [0, 0, 1, 1, 0, 0, 0, 0],
      [0, 0, 0, 1, 1, 0, 0, 0],
      [0, 0, 0, 0, 1, 1, 0, 0],
      [0, 0, 0, 0, 0, 1, 3, 0],
      [0, 0, 0, 0, 0, 0, 1, 1],
    ],
  },
  '2_13': {
    toolbox: toolbox(2, 13),
    ideal: 5,
    requiredBlocks: [[reqBlocks.TURN_LEFT]],
    startDirection: Direction.EAST,
    map: [
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 3, 0, 0],
      [0, 0, 0, 0, 0, 1, 0, 0],
      [0, 0, 0, 0, 0, 1, 0, 0],
      [0, 0, 0, 0, 0, 1, 0, 0],
      [0, 0, 0, 0, 0, 1, 0, 0],
      [0, 0, 0, 2, 1, 1, 0, 0],
      [0, 0, 0, 0, 0, 4, 0, 0],
    ],
    startBlocks: startBlocks(2, 13),
  },
  '2_14': {
    toolbox: toolbox(2, 14),
    ideal: 5,
    scale: {
      stepSpeed: 2,
    },
    requiredBlocks: [
      [reqBlocks.MOVE_FORWARD],
      [reqBlocks.TURN_RIGHT],
      [reqBlocks.IS_PATH_RIGHT],
      [reqBlocks.WHILE_LOOP],
    ],
    startDirection: Direction.EAST,
    map: [
      [0, 0, 0, 4, 0, 0, 0, 0],
      [0, 0, 0, 1, 0, 1, 0, 0],
      [0, 0, 2, 1, 1, 1, 0, 0],
      [0, 0, 0, 0, 0, 1, 0, 0],
      [0, 0, 0, 0, 0, 1, 1, 4],
      [0, 0, 0, 0, 0, 1, 0, 0],
      [0, 3, 1, 1, 1, 1, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
    ],
    levelIncompleteError: mazeMsg.ifInRepeatError(),
  },
  '2_15': {
    toolbox: toolbox(2, 15),
    ideal: 5,
    scale: {
      stepSpeed: 2,
    },
    requiredBlocks: [
      [reqBlocks.MOVE_FORWARD],
      [reqBlocks.TURN_LEFT],
      [reqBlocks.IS_PATH_LEFT],
      [reqBlocks.WHILE_LOOP],
    ],
    startDirection: Direction.NORTH,
    map: [
      [0, 0, 0, 4, 0, 0, 0, 0],
      [0, 0, 0, 1, 0, 0, 0, 0],
      [0, 1, 1, 1, 1, 1, 0, 0],
      [0, 1, 0, 0, 0, 1, 0, 0],
      [0, 1, 0, 3, 0, 1, 0, 0],
      [0, 1, 0, 1, 0, 1, 1, 4],
      [0, 1, 1, 1, 0, 2, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
    ],
  },
  '2_16': {
    toolbox: toolbox(2, 16),
    ideal: 5,
    scale: {
      stepSpeed: 2,
    },
    requiredBlocks: [
      [reqBlocks.MOVE_FORWARD],
      [reqBlocks.TURN_RIGHT],
      [reqBlocks.IS_PATH_RIGHT],
      [reqBlocks.WHILE_LOOP],
    ],
    startDirection: Direction.SOUTH,
    map: [
      [0, 0, 0, 4, 0, 0, 0, 0],
      [0, 0, 0, 1, 0, 0, 0, 0],
      [0, 0, 1, 1, 1, 2, 0, 0],
      [0, 0, 0, 0, 0, 1, 1, 4],
      [0, 1, 1, 3, 0, 1, 0, 4],
      [0, 1, 0, 0, 0, 1, 0, 1],
      [0, 1, 1, 1, 1, 1, 1, 1],
      [0, 0, 0, 0, 0, 0, 0, 0],
    ],
  },
  '2_17': {
    toolbox: toolbox(2, 17),
    ideal: 5,
    scale: {
      stepSpeed: 2,
    },
    requiredBlocks: [
      [reqBlocks.MOVE_FORWARD],
      [reqBlocks.IS_PATH_FORWARD],
      [reqBlocks.TURN_LEFT],
      [reqBlocks.WHILE_LOOP],
    ],
    startDirection: Direction.EAST,
    map: [
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 1, 4, 1, 1, 1, 0, 0],
      [0, 0, 1, 0, 0, 0, 0, 0],
      [3, 1, 1, 1, 1, 1, 1, 0],
      [0, 1, 0, 1, 0, 0, 1, 0],
      [1, 1, 1, 4, 1, 0, 1, 0],
      [0, 1, 0, 1, 0, 2, 1, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
    ],
  },
  '2_18': {
    toolbox: toolbox(2, 18),
    ideal: 5,
    scale: {
      stepSpeed: 2,
    },
    requiredBlocks: [
      [reqBlocks.MOVE_FORWARD],
      [reqBlocks.IS_PATH_FORWARD],
      [reqBlocks.TURN_RIGHT],
      [reqBlocks.WHILE_LOOP],
    ],
    startDirection: Direction.EAST,
    map: [
      [0, 0, 4, 0, 4, 0, 4, 0],
      [0, 0, 1, 0, 1, 0, 1, 0],
      [0, 2, 1, 1, 1, 1, 1, 0],
      [0, 0, 1, 1, 0, 1, 1, 0],
      [0, 0, 0, 0, 0, 0, 1, 0],
      [0, 0, 1, 1, 0, 1, 1, 0],
      [0, 1, 3, 1, 1, 1, 1, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
    ],
  },
  '2_19': {
    toolbox: toolbox(2, 19),
    ideal: 7,
    scale: {
      stepSpeed: 2,
    },
    requiredBlocks: [
      [reqBlocks.MOVE_FORWARD],
      [reqBlocks.TURN_LEFT],
      [reqBlocks.TURN_RIGHT],
    ],
    startDirection: Direction.NORTH,
    map: [
      [1, 1, 1, 1, 1, 1, 1, 1],
      [1, 0, 0, 0, 0, 0, 0, 1],
      [1, 0, 1, 1, 1, 1, 1, 1],
      [1, 0, 1, 0, 0, 0, 0, 0],
      [1, 0, 1, 0, 1, 1, 1, 1],
      [1, 0, 1, 0, 3, 0, 0, 1],
      [1, 0, 1, 0, 0, 0, 0, 1],
      [2, 0, 1, 1, 1, 1, 1, 1],
    ],
    startBlocks: startBlocks(2, 19),
  },

  // Copied levels with editCode enabled
  '3_1': {
    toolbox: toolbox(3, 1),
    ideal: 3,
    editCode: true,
    codeFunctions: {
      moveForward: null,
      turnLeft: null,
      turnRight: null,
    },
    requiredBlocks: [[reqBlocks.MOVE_FORWARD]],
    startDirection: Direction.EAST,
    map: [
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 2, 1, 3, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
    ],
  },
  '3_2': {
    toolbox: toolbox(3, 2),
    ideal: 4,
    editCode: true,
    codeFunctions: {
      moveForward: null,
      turnLeft: null,
      turnRight: null,
    },
    requiredBlocks: [[reqBlocks.MOVE_FORWARD]],
    startDirection: Direction.SOUTH,
    map: [
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 2, 0, 0, 0, 0],
      [0, 0, 0, 1, 0, 0, 0, 0],
      [0, 0, 0, 1, 0, 0, 0, 0],
      [0, 0, 0, 3, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
    ],
  },
  '3_3': {
    toolbox: toolbox(3, 3),
    ideal: 6,
    editCode: true,
    codeFunctions: {
      moveForward: null,
      turnLeft: null,
      turnRight: null,
    },
    requiredBlocks: [
      [reqBlocks.MOVE_FORWARD],
      [reqBlocks.TURN_LEFT],
      [reqBlocks.TURN_RIGHT],
    ],
    startDirection: Direction.EAST,
    map: [
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 4, 1, 3, 0, 0, 0],
      [0, 0, 2, 1, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
    ],
  },
  '3_4': {
    toolbox: toolbox(3, 4),
    ideal: 8,
    editCode: true,
    codeFunctions: {
      moveForward: null,
      turnLeft: null,
      turnRight: null,
    },
    requiredBlocks: [[reqBlocks.MOVE_FORWARD], [reqBlocks.TURN_LEFT]],
    startDirection: Direction.EAST,
    map: [
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 2, 4, 3, 0, 0, 0],
      [0, 0, 1, 1, 1, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
    ],
  },
  custom: {
    toolbox: toolbox(3, 4),
    requiredBlocks: [],
    startDirection: Direction.EAST,
    map: [
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 2, 4, 3, 0, 0, 0],
      [0, 0, 1, 1, 1, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
    ],
  },
};

// Merge in Karel levels.
for (var levelId in karelLevels) {
  module.exports['karel_' + levelId] = karelLevels[levelId];
}

// Merge in Wordsearch levels.
for (levelId in wordsearchLevels) {
  module.exports['wordsearch_' + levelId] = wordsearchLevels[levelId];
}

// Add some step levels
function cloneWithStep(level, step, stepOnly) {
  var obj = utils.extend({}, module.exports[level]);

  obj.step = step;
  obj.stepOnly = stepOnly;
  module.exports[level + '_step'] = obj;
}

cloneWithStep('2_1', true, true);
cloneWithStep('2_2', true, false);
cloneWithStep('2_17', true, false);
cloneWithStep('karel_1_9', true, false);
cloneWithStep('karel_2_9', true, false);
